import * as React from 'react';

import classnames from 'classnames';

import type {Cell} from '../types';

import {getCellTitle} from './helpers';
import {TableRowCheckbox} from './table-row-checkbox';

import styles from './table-cell.module.css';

type Props<T> = {
    cell: Cell<T>;
    isResizable: boolean;
    isCompact: boolean;
    hasLessBottomPadding: boolean;
    hasCellBorders: boolean;
    showCheckbox: boolean;
    rightAlign?: boolean;
};

export function TableCell<T>(props: Props<T>) {
    const {cell, isResizable, hasCellBorders, isCompact, showCheckbox, hasLessBottomPadding} =
        props;
    const shouldTruncate = cell.column.shouldTruncate;
    const hasRightBorder = cell.column.hasRightBorder;
    const hasLeftBorder = cell.column.hasLeftBorder;
    const shouldRightAlign =
        cell.column.rightAlign ||
        cell.column.dataType === 'integer' ||
        cell.column.dataType === 'percentage';
    const shouldCenterAlign = cell.column.centerAlign;

    const TD = isResizable ? 'div' : 'td';

    const styleNames = classnames(styles['table-cell'], {
        [styles['border--right']]: hasCellBorders || hasRightBorder,
        [styles['border--left']]: hasLeftBorder,
        [styles['data-type--right-align']]: shouldRightAlign,
        [styles['data-type--center-align']]: shouldCenterAlign,
        [styles.compact]: isCompact,
        [styles['less-bottom-padding']]: hasLessBottomPadding,
        [styles['text-is-dk-grey']]: cell.column.textIsDkGrey,
        [styles['is-top-aligned']]: cell.column.isTopAligned,
        [styles['edit-in-place']]: cell.column.isEditInPlace,
        [styles.wrap]: cell.column.shouldWrap,
    });

    return (
        <TD {...cell.getCellProps()} className={styleNames}>
            {showCheckbox && cell.row.getToggleRowSelectedProps ? (
                <TableRowCheckbox getToggleRowSelectedProps={cell.row.getToggleRowSelectedProps} />
            ) : null}
            {shouldTruncate ? (
                <span
                    title={getCellTitle(cell.value, cell.column.titleKey, cell.column.dataType)}
                    className={styles.truncated}
                >
                    {cell.render('Cell')}
                </span>
            ) : (
                cell.render('Cell')
            )}
        </TD>
    );
}
